import VoucherInputContainer from './VoucherInputContainer';
export default VoucherInputContainer;